<template>
    <v-card>
        <v-card-title style="font-size: 1.3em">Editar Versão do APP</v-card-title>
        <v-card-text>
            <v-text-field v-model="versao_minima_app_cliente" label="Versão do app Apetrus"></v-text-field>
            <v-text-field v-model="versao_minima_app_frentista" label="Versão do app do Frentista"></v-text-field>
            <v-text-field v-model="versao_minima_app_apetrus_pago" label="Versão do app Apetrus Pago"></v-text-field>
            <v-text-field v-model="versao_minima_app_apetrus_frota" label="Versão do app Apetrus Frota"></v-text-field>
            <v-text-field v-model="versao_minima_app_apetrus_veiculo" label="Versão do app Apetrus Veiculos"></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-btn round @click="$emit('fechar')">Fechar</v-btn>
            <v-btn round color="success" @click="atualizarVersao">Salvar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        versao_minima_app_cliente: undefined,
        versao_minima_app_frentista: undefined,
        versao_minima_app_apetrus_pago: undefined,
        versao_minima_app_apetrus_frota: undefined,
        versao_minima_app_apetrus_veiculo: undefined
    }),
    methods: {
        pegarVersoes () {
            this.$store.dispatch('versaoApp', { method: 'GET' }).then(versoes => {
                this.versao_minima_app_cliente = versoes.versao_minima_app_cliente
                this.versao_minima_app_frentista = versoes.versao_minima_app_frentista
                this.versao_minima_app_apetrus_pago = versoes.versao_minima_app_apetrus_pago
                this.versao_minima_app_apetrus_frota = versoes.versao_minima_app_apetrus_frota
                this.versao_minima_app_apetrus_veiculo = versoes.versao_minima_app_apetrus_veiculo
            })
        },
        atualizarVersao () {
            this.$store.dispatch('versaoApp', {
                method: 'POST',
                versao_minima_app_cliente: this.versao_minima_app_cliente,
                versao_minima_app_frentista: this.versao_minima_app_frentista,
                versao_minima_app_apetrus_pago: this.versao_minima_app_apetrus_pago,
                versao_minima_app_apetrus_frota: this.versao_minima_app_apetrus_frota,
                versao_minima_app_apetrus_veiculo: this.versao_minima_app_apetrus_veiculo
            }).then(() => {
                this.$emit('success', 'A Versão do App foi atualizada.')
            }).catch(() => {
                this.$emit('error', 'Erro ao tentar atualizar versão do App.')
            })
        }
    },
    beforeMount () {
        this.pegarVersoes()
    }
}
</script>
